import Player from './wrapper.vue';
import Clickoutside from '../../utils/clickoutside';
import Uid from '../../directives/uid';
export let _Vue;
Player.install = function(Vue) {
  _Vue = Vue;
  Vue.component(Player.name, Player);
  const directives = {
    Clickoutside,
    Uid
  };

  Object.keys(directives).forEach((name) =>
    Vue.directive(name, directives[name])
  );

};

export default Player;
